export default "__VITE_ASSET__150caa32__"